:host {
  display: block;
  width: 100%;
}

.sportsline-free-expert-pick--loading {
  display: grid;
  min-height: 6rem;
  place-items: center;
}
